<template lang="pug">
  #show-customer-data
    b-container(fluid="fluid")
      template(v-if="isLoading === true")
        loading(:height="200")
      template(v-else)
        b-row
          b-col
            h4(:class="title_class")
              label ご契約者情報
              //b-button.ml-2(variant="outline-info", size="sm", :to="{name: 'ChangeCustomerInfo'}") 変更
            b-row.border-top.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") お客様番号
              b-col(:class="customer_data_col_class" data-testid="text_client_no") {{client_no}}
            b-row.border-top.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") 会社名・組織名
              b-col(:class="customer_data_col_class" data-testid="text_firm_name") {{firm_name}}
            b-row.border-top.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") 会社名・組織名(かな)
              b-col(:class="customer_data_col_class" data-testid="text_firm_kana") {{firm_kana}}
            b-row.border-top.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") 代表者名
              b-col(:class="customer_data_col_class" data-testid="text_president_name") {{president_name}}
            b-row.border-top.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") 代表者名(かな)
              b-col(:class="customer_data_col_class" data-testid="text_president_kana") {{president_kana}}
            b-row.border-top.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") 部署名
              b-col(:class="customer_data_col_class" data-testid="text_department") {{department}}
            b-row.border-top.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") 担当者名
              b-col(:class="customer_data_col_class" data-testid="text_person_name") {{person_name}}
            b-row.border-top.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") 担当者名(かな)
              b-col(:class="customer_data_col_class" data-testid="text_person_kana") {{person_kana}}
            b-row.border-top.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") 郵便番号
              b-col(:class="customer_data_col_class" data-testid="text_zip_code") {{zip_code}}
            b-row.border-top.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") 住所
              b-col(:class="customer_data_col_class" data-testid="text_address") {{address}}
            b-row.border-top.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") 電話番号
              b-col(:class="customer_data_col_class" data-testid="text_tel") {{tel}}
            b-row.border-top.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") FAX番号
              b-col(v-if="fax", :class="customer_data_col_class" data-testid="text_fax") {{fax}}
              b-col(v-else, :class="customer_data_light_font_color_class" data-testid="text_fax") ご登録情報がありません
            b-row.border-top.border-bottom.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") E-mail
                //b-button.ml-2(variant="outline-info", size="sm", :to="{name: 'ChangeMail'}") 変更
              b-col(:class="customer_data_col_class" data-testid="text_e_mail") {{e_mail}}
            b-form-text(style="height: 30px;")

        b-row(v-if="sales_channel === '0'")
          b-col
            h4(:class="title_class")
              label ご契約種別・お支払い方法
            b-row.border-top.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") ご契約種別
              b-col(v-if="billing_period.length > 0", :class="customer_data_col_class" data-testid="text_billing_period")
                p.mb-0(v-for="billing_period in billing_period") {{setFlagValue(billing_period, billing_period_flg_var)}}
              b-col(v-else, :class="customer_data_col_class" data-testid="text_billing_period") 環境構築中です
            b-row.border-top.border-bottom.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") お支払い方法
              b-col(:class="customer_data_col_class" data-testid="text_payment_type") {{payment_type}}
            b-form-text(style="height: 30px;")

        b-row(v-if="sales_channel === '0'")
          b-col
            h4(:class="title_class")
              label 請求書宛名情報
              //b-button.ml-2(variant="outline-info", size="sm", :to="{name: 'ChangeCustomerInfo'}") 変更
            b-row.border-top.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") 会社名・組織名
              b-col(:class="customer_data_col_class" data-testid="text_bill_firm_name") {{bill_firm_name}}
            b-row.border-top.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") 会社名・組織名(かな)
              b-col(:class="customer_data_col_class" data-testid="text_bill_firm_kana") {{bill_firm_kana}}
            b-row.border-top.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") 部署名
              b-col(:class="customer_data_col_class" data-testid="text_bill_department") {{bill_department}}
            b-row.border-top.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") 担当者名
              b-col(:class="customer_data_col_class" data-testid="text_bill_person_name") {{bill_person_name}}
            b-row.border-top.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") 担当者名(かな)
              b-col(:class="customer_data_col_class" data-testid="text_bill_person_kana") {{bill_person_kana}}
            b-row.border-top.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") 郵便番号
              b-col(:class="customer_data_col_class" data-testid="text_bill_zip_code") {{bill_zip_code}}
            b-row.border-top.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") 住所
              b-col(:class="customer_data_col_class" data-testid="text_bill_address") {{bill_address}}
            b-row.border-top.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") 電話番号
              b-col(:class="customer_data_col_class" data-testid="text_bill_tel") {{bill_tel}}
            b-row.border-top.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") FAX番号
              b-col(v-if="bill_fax", :class="customer_data_col_class" data-testid="text_bill_fax") {{bill_fax}}
              b-col(v-else, :class="customer_data_light_font_color_class" data-testid="text_bill_fax") ご登録情報がありません
            b-row.border-top.border-bottom.ml-3.mr-1
              b-col(cols="3", :class="customer_title_col_class") E-mail
              b-col(:class="customer_data_col_class" data-testid="text_bill_e_mail") {{bill_e_mail}}
        p.ml-3(v-if="sales_channel === '1'").text-danger ※ ご契約者情報の変更は販売店にお問い合わせください。
</template>

<script>
import Api from "@/repositories/api";
import Loading from '@/components/Loading'
import { cl_contract_details_tbl as lang_cl_contract_details_tbl } from '@/lang/ja_JP'
import { cl_client_tbl as lang_cl_client_tbl } from '@/lang/ja_JP'

const S207CustomerDetailsRepository = Api.get('s207CustomerDetails')

export default {
  name: "ShowCustomerData",
  components: {
    Loading
  },
  props: {
    sales_channel: { type: String, require: true }
  },
  data() {
    return {
      customer_service_title_class: "font-weight-bold ml-3 border-top border-bottom py-2 customer-title-bg-color",
      customer_title_col_class: "py-2 px-2 border-right font-weight-bold table-title-col-width",
      customer_data_col_class: "py-2 px-2 overflow",
      customer_data_light_font_color_class: "py-2 px-2 light-font-color",

      title_class: "ml-3 customer-title-bg-color font-weight-bold mb-0 pt-2 pb-1",
      title_font_class: "font-weight-bold pt-2 mb-0",

      // テスト用
      customer_data_col_class2 : "py-2 px-2 border-right",

      /**
       * ご契約者情報
       */
      // 顧客番号
      client_no: "",
      // 会社名・組織名
      firm_name: "",
      // 会社名・組織名(かな)
      firm_kana: "",
      // 代表者名
      president_name: "",
      // 代表者名かな
      president_kana: "",
      // 部署名
      department: "",
      // 担当者名
      person_name: "",
      // 担当者名かな
      person_kana: "",
      // 郵便番号
      zip_code: "",
      // 住所
      address: "",
      // 電話番号
      tel: "",
      // FAX番号
      fax: "",
      // メールアドレス
      e_mail: "",

      /**
       * ご契約種別・お支払い方法
       */
      // 請求単位
      billing_period: [],
      // お支払い方法
      payment_type: "",

      /**
       * 請求書宛名情報
       */
      // 請求先会社名・組織名
      bill_firm_name: "",
      // 請求先会社名・組織名(かな)
      bill_firm_kana: "",
      // 請求先部署名
      bill_department: "",
      // 請求先担当者名
      bill_person_name: "",
      // 請求先担当者名かな
      bill_person_kana: "",
      // 請求先郵便番号
      bill_zip_code: "",
      // 請求先住所
      bill_address: "",
      // 請求先電話番号
      bill_tel: "",
      // 請求先FAX番号
      bill_fax: "",
      // 請求先メールアドレス
      bill_e_mail: "",

      // 請求単位の定義値
      billing_period_flg_var: lang_cl_contract_details_tbl.bill_period,
    }
  },

  created() {
    // 読み込み中
    this.isLoading = true;

    S207CustomerDetailsRepository.get().
    then((response) => {
      // お客様情報をセットする
      for (let param in response.data.data.customer_info) {
        // 支払い方法
        if (param === 'payment_type') {
          // 定義値を参照する
          this[param] = lang_cl_client_tbl.payment_type[response.data.data.customer_info[param]]
        }
        else {
          this[param] = response.data.data.customer_info[param]
        }
      }
    })
    .catch((error) =>{
      // 共通のエラー処理
      this.apiError(error, '画面表示処理', "Support")

      // エラーメッセージをセットする
      this.setErrors(error)
    })
    .finally(() => [
      // 読み込み完了
      this.isLoading = false
    ])
  }
}
</script>

<style scoped>
.customer-title-bg-color {
  background-color: #f5f5f5;
}
.table-title-col-width {
  max-width: 221px;
}
.light-font-color {
  color: #c0c0c0;
}
.overflow {
  overflow: auto;
}
</style>